/** @format */

import classNames from 'classnames'
import React from 'react'

export default function HeroHeading({children,className,...props}) {
  return <h1 className={classNames("text-dark text-3xl lg:text-5xl font-bold !leading-tight",className)}>{children}</h1>
}
